export const unitTypes = ['PORTATIL', 'ESTACIONARIO', 'TODOS']
export const jobs = ['CHOFER_SOLO', 'CHOFER_AYUDANTE', 'CHOFER', 'AYUDANTE', 'TODOS']
export const prePayrollBasePaymentPeriods = ['SEMANAL', 'MENSUAL']
export const prePayrollBaseCalcs1 = ['SEMANAL', 'MENSUAL']
export const prePayrollBaseCalcs2 = ['DIARIO', 'SEMANAL', 'PROMEDIO_DIARIO_SEMANAL']
export const tabulatorUses = ['RANGO_UNICO', 'EXCEDENTES', 'COMISION_UNICA_X_RANGO']
export const homologations = ['LTS', 'LTS_CONTADO', 'LTS_CREDITO', 'KILOS', 'CILS_A_20', 'CILS_A_30', 'CILS_A_45', 'CILS_OTROS', 'SERVICIOS', 'PRODUCTIVIDAD', 'VIAJES']
export const monthsOptions = [
  { 
    value: 0, 
    month: 'ENERO' 
  },
  { 
    value: 1, 
    month: 'FEBRERO' 
  },
  { 
    value: 2, 
    month: 'MARZO' 
  },
  { 
    value: 3, 
    month: 'ABRIL' 
  },
  { 
    value: 4, 
    month: 'MAYO' 
  },
  { 
    value: 5, 
    month: 'JUNIO' 
  },
  { 
    value: 6, 
    month: 'JULIO' 
  },
  { 
    value: 7, 
    month: 'AGOSTO' 
  },
  { 
    value: 8, 
    month: 'SEPTIEMBRE' 
  },
  { 
    value: 9, 
    month: 'OCTUBRE' 
  },
  { 
    value: 10, 
    month: 'NOVIEMBRE' 
  },
  { 
    value: 11, 
    month: 'DICIEMBRE' 
  },
]

export const rulesOptions = [
  {
    id: "01943239120874123451",
    name: "Distición de tipo de ruta",
    noteKey: "ruteType",
    type: "NORMAL",
    ruleKeys: [
      {
        id: "97936482648263826313",
        value: "LOCAL"
      },
      {
        id: "97936482648263821423",
        value: "FORANEA"
      },
    ]
  },
  {
    id: "01943239120874124444",
    name: "Distición de tipo de pago",
    noteKey: "paymentType",
    type: "NORMAL",
    ruleKeys: [
      {
        id: "97936482648263826333",
        value: "CREDITO"
      },
      {
        id: "97936482648263821444",
        value: "CONTADO"
      },
    ]
  },
  {
    id: "01943239120874124422",
    name: "Distición de tipo de movimiento",
    noteKey: "movementType",
    type: "NORMAL",
    ruleKeys: [
      {
        id: "97936482648263824646",
        value: "TRASPASO"
      },
      {
        id: "97936482648263828484",
        value: "VENTA"
      },
    ]
  },
  {
    id: "01943239120874123422",
    name: "Distición por temporada",
    noteKey: "date",
    type: "SEASON",
    ruleKeys: []
  },
  {
    id: "01943239124684684684",
    name: "Distición por giro del cliente",
    noteKey: "customerType",
    type: "CUSTOMER_TYPE",
    ruleKeys: [
      {
        id: "97936482648284848484",
        value: "DOMESTICO"
      },
      {
        id: "97936482640101010101",
        value: "CONDOMINIO"
      },
    ]
  },
  {
    id: "01943239120123123123",
    name: "Distición por cliente",
    noteKey: "customerId",
    type: "CUSTOMER",
    ruleKeys: []
  },
]